import { render, staticRenderFns } from "./GenelIslemFormWizard.vue?vue&type=template&id=2cedd292&scoped=true"
import script from "./GenelIslemFormWizard.vue?vue&type=script&lang=ts"
export * from "./GenelIslemFormWizard.vue?vue&type=script&lang=ts"
import style0 from "./GenelIslemFormWizard.vue?vue&type=style&index=0&id=2cedd292&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cedd292",
  null
  
)

export default component.exports